import FadedText from "@components/FadedText";
import { Row } from "@components/Layout";
import { FaSolidEye, FaSolidEyeSlash } from "solid-icons/fa";
import { For, type JSX, Match, Show, Switch, createMemo, createSignal, onMount, splitProps } from "solid-js";
import ErrorMessage from "./components/ErrorMessage";
import { EyeWrapper, IconWrapper, InputBase, InputField, InputLabel, InputWrapper, TextAreaField } from "./styled";
import type { InputProps } from "./types";

const Input = <T, U>(props: InputProps<T, U>) => {
	const [type, setType] = createSignal<JSX.InputHTMLAttributes<HTMLInputElement>["type"]>("text");
	const [local, others] = splitProps(props, ["ref", "onfocus", "onblur"]);

	onMount(() => setType(props.type));

	const parseIssues = createMemo(() => (props.parseResult?.success ? undefined : props.parseResult?.error.issues));

	return (
		<InputBase
			w="100%"
			validationState={!!parseIssues()?.length && !!props.value?.toString().length ? "invalid" : "valid"}
			{...others}
		>
			<Show when={props.label}>
				<InputLabel for={props.name}>{props.label}</InputLabel>
			</Show>
			<InputWrapper>
				<Show when={props.icon}>
					<IconWrapper>{props.icon}</IconWrapper>
				</Show>
				<Show
					when={props.textArea}
					fallback={
						<InputField
							p={props.p}
							type={type()}
							placeholder={props.placeholder}
							passwordType={props.type === "password"}
							alternative={props.alternative}
							ref={local.ref}
							autofocus={props.autofocus}
							icon={!!props.icon}
							h={props.h}
							onfocus={props.onfocus}
							onblur={props.onblur}
						/>
					}
				>
					<TextAreaField placeholder={props.placeholder} rows={4} resize={props.resize} />
				</Show>

				<Show when={props.type === "password"}>
					<EyeWrapper onClick={() => setType(type() === "password" ? "text" : "password")} clickable>
						<Switch>
							<Match when={type() === "password"}>
								<FaSolidEye size={18} />
							</Match>
							<Match when={type() === "text"}>
								<FaSolidEyeSlash size={18} />
							</Match>
						</Switch>
					</EyeWrapper>
				</Show>
			</InputWrapper>
			<Show when={props.max}>
				<Row justifyContent="flex-end" margin="0 0 -7px" padding="2px 0 0">
					<FadedText fontSize="13px">
						{props.value?.length}/{props.max}
					</FadedText>
				</Row>
			</Show>
			<For each={parseIssues()}>{(e) => <ErrorMessage error={e} />}</For>
		</InputBase>
	);
};
export default Input;
